import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';

@Component({
    selector: 'app-page-content-loop',
    templateUrl: './page-content-loop.component.html',
    styleUrls: ['./page-content-loop.component.scss'],
    standalone: false
})
export class PageContentLoopComponent implements OnInit {
  @Input() pageContents: PageContentModel[]
  currentLang: string

  constructor(public translateService: TranslateService, private router: Router) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang)
  }

  ngOnInit(): void { }
}
